import { supabase } from "../lib/supabaseClient";

export type AIGenerationStatus = "completed" | "failed";

export type AIGeneration = {
  id: string;
  board_id: string | null;
  user_id: string;
  prompt: string;
  response: unknown;
  generation_type: string;
  model: string;
  status: AIGenerationStatus;
  created_at: string;
};

type CreateAIGenerationParams = {
  userId: string;
  boardId?: string | null;
  prompt: string;
  generationType: string;
  response: unknown;
  model: string;
  status: AIGenerationStatus;
};

export const createAIGeneration = async ({
  userId,
  boardId,
  prompt,
  generationType,
  response,
  model,
  status,
}: CreateAIGenerationParams) => {
  const { data, error } = await supabase
    .from("ai_generations")
    .insert({
      user_id: userId,
      board_id: boardId ?? null,
      prompt,
      response,
      generation_type: generationType,
      model,
      status,
    })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data as AIGeneration;
};

export const getAIGenerations = async (userId: string, limit = 10) => {
  const { data, error } = await supabase
    .from("ai_generations")
    .select("*")
    .eq("user_id", userId)
    .order("created_at", { ascending: false })
    .limit(limit);

  if (error) {
    throw error;
  }

  return data as AIGeneration[];
};
